import {
  HHAccordion,
  HHAccordionDetails,
  HHAccordionSummary,
  HHTypography,
} from '@hinge-health/react-component-library';
import { ExpandMore } from '@mui/icons-material';
import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { ReactNode } from 'react';

interface DetailsAccordionProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  // Draws a bordered card. For standalone use — with the shadow and divider
  // stripped below, an unbordered summary row reads as plain text.
  bordered?: boolean;
}

const DetailsAccordion = ({
  title,
  children,
  defaultExpanded = false,
  bordered = false,
}: DetailsAccordionProps): JSX.Element => (
  <HHAccordion
    defaultExpanded={defaultExpanded}
    disableGutters
    sx={(theme): SystemStyleObject<Theme> => ({
      boxShadow: 'none',
      '&:before': {
        display: 'none',
      },
      backgroundColor: theme.palette.background.paper,
      ...(bordered && {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '8px',
        // MUI's per-corner radii under :first/:last-of-type outrank a bare
        // borderRadius.
        '&:first-of-type, &:last-of-type': { borderRadius: '8px' },
        overflow: 'hidden',
      }),
    })}
  >
    <HHAccordionSummary
      expandIcon={<ExpandMore />}
      sx={{
        // On the summary, not a wrapper, so the hit area spans the full card.
        padding: bordered ? '0 16px' : 0,
        margin: 0,
      }}
    >
      <HHTypography hhVariant="subtitle1">{title}</HHTypography>
    </HHAccordionSummary>
    <HHAccordionDetails>{children}</HHAccordionDetails>
  </HHAccordion>
);

export default DetailsAccordion;
